import axios from 'axios'

type PollOpts = {
  url: string
  isDone: (data: any) => boolean
  onDone: (data: any) => void
  withCredentials?: boolean
  intervalMs?: number
  attempts?: number
}

/**
 * Poll a payment status endpoint until it reports a terminal state.
 * Returns a cancel function. The payment overlay is NOT auto-closed — the user
 * closes it after copying their transaction details.
 */
export const pollPaymentStatus = ({
  url,
  isDone,
  onDone,
  withCredentials = false,
  intervalMs = 2500,
  attempts = 120,
}: PollOpts): (() => void) => {
  let stopped = false
  let n = 0
  const tick = async () => {
    if (stopped) return
    try {
      const { data } = await axios.get(url, { withCredentials })
      if (isDone(data)) {
        stopped = true
        onDone(data)
        return
      }
    } catch (e) {
      /* transient — keep trying */
    }
    if (++n >= attempts) {
      stopped = true
      return
    }
    setTimeout(tick, intervalMs)
  }
  setTimeout(tick, intervalMs)
  return () => {
    stopped = true
  }
}
